import { agentLabel } from './format';

export function sessionStatus(session, tasks = [], outputs = {}) {
  const attention = text => ({ text, attention: true });
  if (session.moderation?.restricted) return attention('Работа ограничена администратором');
  if (session.status === 'waiting_for_human') return attention('Нужен ваш ответ');
  if (session.pause_reason === 'token_quota_exceeded' && session.status === 'paused') return { text: 'Ожидает обновления лимита клиента' };
  if (session.status === 'failed') return attention('Исследование остановлено из-за ошибки');
  if (session.status === 'paused') return { text: 'Исследование приостановлено' };
  if (session.status === 'cancelled') return { text: 'Исследование отменено · материалы сохранены' };
  if (session.status === 'running' && session.continuation?.state === 'recovering') return attention('Восстанавливаю продолжение · итог ещё не готов');
  if (session.stop_state === 'finishing_action') return { text: 'Завершается текущее действие…' };
  if (outputs.failed) return attention('Не удалось подготовить часть файлов · нужен повтор');
  if (outputs.needsReview) return attention('Материалы требуют проверки качества');
  if (outputs.preparing || (session.current_phase === 'finalization' && session.status !== 'finished')) return { text: 'Подготавливаю результаты' };
  if (session.status === 'finished') return {
    text: session.research?.result_completeness === 'partial' ? 'Исследование завершено с ограничениями' : 'Исследование завершено',
    attention: session.research?.result_completeness === 'partial',
  };
  if (session.continuation?.state === 'planning') return { text: 'Анализирую материалы и определяю следующий шаг' };
  if (session.continuation?.state) return { text: 'Подготавливаю продолжение исследования' };
  const running = tasks.filter(task => ['running', 'waiting_tool'].includes(task.status))
    .sort((a, b) => (Date.parse(b.started_at) || 0) - (Date.parse(a.started_at) || 0));
  if (!running.length) return { text: 'Исследование продолжается' };
  const agent = agentLabel(running[0].assigned_to);
  return { text: `В работе: ${agent} — ${running[0].objective}`, agent, objective: running[0].objective };
}
